import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BackArrow from "@/icons/common/back-arrow.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  action: {
    type: Function,
    default: () => ({}),
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "back-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.action()))
  }, [
    _createVNode(BackArrow)
  ]))
}
}

})